import EventDay from './EventDay';
import { useDispatch, useSelector } from 'react-redux';
import { actions as calendarActions, getModuleState } from 'services/calendar';
import { eventUserStatuses } from 'lib/enums/eventUserStatuses';
import { useStatusObject } from 'pages/SchedulePage/utils/statusObject';


const EventDayWrapper = ({ event, style, onClick, ...props }) => {
  const dispatch = useDispatch();
  const calendarState = useSelector(getModuleState);
  const { selectedEvent } = calendarState;
  
  const isSelected = selectedEvent?.eventId === event?.id;
  
  const statusObject = useStatusObject()
  const getBackgroundColorForContainer = (event) => {
    return event.status === eventUserStatuses.booked
      ? statusObject.APPROVED.hexBgColor
      : statusObject.AWAITING.hexBgColor;
  };

  return (
    <div
      className="rbc-event"
      style={{
        ...style,
        top: style?.top + '%',
        backgroundColor: getBackgroundColorForContainer(event),
        overflow: isSelected ? 'visible' : 'hidden',
        zIndex: isSelected ? 1001 : 100,
      }}
      onMouseEnter={() => {
        dispatch(
          calendarActions.highlightEvent({
            eventId: event.id,
          })
        );
      }}
      onMouseLeave={() => {
        dispatch(calendarActions.highlightEvent({ eventId: null }));
      }}
      onClick={onClick}
    >
      <div className="rbc-event-content">
        <EventDay event={event} />
      </div>
    </div>
  );
};

export default EventDayWrapper;
